"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryCodeFromOriginHelper = void 0;
const getCountryCodeFromOriginHelper = (origin) => {
    const usMarketplace = 'us';
    const usTopLevelDomain = 'com';
    const nonProdKeywords = ['development', 'pre-prod', 'beta', 'gamma'];
    const pattern = new RegExp(`(\\w+)-(?:${nonProdKeywords.join('|')})`);
    const match = origin.match(pattern);
    if (match) {
        return match[1];
    }
    const lastDotIndex = origin.lastIndexOf('.');
    const topLevelDomain = origin.slice(lastDotIndex + 1);
    if (topLevelDomain === usTopLevelDomain) {
        return usMarketplace;
    }
    return topLevelDomain;
};
exports.getCountryCodeFromOriginHelper = getCountryCodeFromOriginHelper;
